(() => {
  function init(root = document) {
    const form = root.querySelector('#RjDesignTableForm');
    if (!form || form.dataset.enhanced) return;
    const page = form.closest('.rb-design');
    const params = new URLSearchParams(window.location.search);
    const model = (params.get('model') || '').slice(0, 160);
    const variant = (params.get('variant') || '').slice(0, 100);
    let origin = model ? model + (variant && variant !== 'Default Title' ? ' · ' + variant : '') : '';
    const originField = form.querySelector('[data-bespoke-origin]');
    const originLabel = form.querySelector('[data-bespoke-origin-label]');
    if (origin && originField && originLabel) {
      originField.value = origin;
      originLabel.textContent = 'Dit udgangspunkt: ' + origin + '. Du kan tilpasse ønskerne nedenfor.';
      originLabel.hidden = false;
    }
    const stages = [...form.querySelectorAll('[data-stage]')];
    const nav = page.querySelector('.rb-progress');
    const navButtons = [...nav.querySelectorAll('[data-go-stage]')];
    const controls = form.querySelector('.rb-step-controls');
    const back = controls.querySelector('[data-design-back]');
    const next = controls.querySelector('[data-design-next]');
    const submitArea = form.querySelector('.rj-table-design__submit');
    const summary = page.querySelector('.rb-summary');
    let stage = 0;
    const stepStatus = page.querySelector('[data-step-status]');
    const presets = page.querySelector('[data-size-presets]');
    const editChoices = page.querySelector('[data-edit-choices]');
    const detailReset = form.querySelector('[data-clear-details]');
    const value = key => form.elements['contact[' + key + ']']?.value || '';
    const round = () => value('form') === 'Rundt';
    function toggle(selector, active) {
      const area = form.querySelector(selector);
      area.hidden = !active;
      area.querySelectorAll('input,textarea').forEach(field => { field.disabled = !active; });
    }
    const storageKey = 'ruskjaer-bordide-v1';
    const savedKeys = ['form','længde_cm','bredde_cm','diameter_cm','træsort','udtryk','ben','tillægsplader'];
    const saveTools = page.querySelector('[data-save-tools]');
    const saveStatus = page.querySelector('[data-save-status]');
    const restoreButton = page.querySelector('[data-restore-design]');
    const forgetButton = page.querySelector('[data-forget-design]');
    let savedDesign = null;
    try {
      const raw = localStorage.getItem(storageKey);
      if(raw) {
        const data = JSON.parse(raw);
        if(data.version === 1 && Date.now() - data.at < 30 * 86400000 && data.values && typeof data.values === 'object') savedDesign = data;
        else localStorage.removeItem(storageKey);
      }
    } catch (_) { /* Storage is optional. The enquiry remains fully usable. */ }
    restoreButton.hidden = forgetButton.hidden = !savedDesign;
    if(savedDesign) saveStatus.textContent = 'Du har en gemt bordidé på denne enhed. Hent den, når du vil fortsætte.';
    page.querySelector('[data-save-design]').addEventListener('click', () => {
      const data = {version:1, at:Date.now(), values:Object.fromEntries(savedKeys.map(key=>[key,value(key)]))};
      try {
        localStorage.setItem(storageKey, JSON.stringify(data)); savedDesign=data;
        restoreButton.hidden = forgetButton.hidden = false;
        saveStatus.textContent = 'Din bordidé er gemt i 30 dage på denne enhed. Kontaktoplysninger og fritekst er ikke gemt.';
      } catch (_) { saveStatus.textContent = 'Browseren kunne ikke gemme bordidéen. Du kan stadig sende din forespørgsel her.'; }
    });
    restoreButton.addEventListener('click', () => {
      if(!savedDesign) return;
      savedKeys.forEach(key => {
        const inputs = [...form.querySelectorAll('input')].filter(input=>input.name === 'contact['+key+']');
        const stored = String(savedDesign.values[key] || '').slice(0,80);
        inputs.forEach(input => {
          if(input.type === 'radio') input.checked = input.value === stored;
          else if(input.type === 'number') {
            const number = Number(stored);
            input.value = stored && Number.isFinite(number) && number >= Number(input.min) && number <= Number(input.max) ? stored : '';
          }
        });
      });
      if(!value('form')) form.querySelector('input[value="Rektangulært / firkantet"]').checked=true;
      origin=''; originField.value=''; originLabel.hidden=true;
      sync(); showStage(0);
      saveStatus.textContent = 'Dine gemte bordvalg er hentet. Tilføj eventuelle særlige ønsker igen, før du sender.';
    });
    forgetButton.addEventListener('click', () => {
      try {localStorage.removeItem(storageKey); savedDesign=null;restoreButton.hidden=forgetButton.hidden=true;saveStatus.textContent='Den gemte kopi er slettet. Dine aktuelle valg står stadig her.';}
      catch (_) {saveStatus.textContent='Browseren kunne ikke slette den gemte kopi. Du kan slette webstedsdata i browserens indstillinger.';}
    });
    const previewToggle=page.querySelector('[data-preview-toggle]');
    previewToggle.addEventListener('click', () => {
      const open=previewToggle.getAttribute('aria-expanded') !== 'true';
      previewToggle.setAttribute('aria-expanded',String(open)); summary.classList.toggle('is-open',open);
      previewToggle.querySelector('[aria-hidden]').textContent=open?'−':'＋';
    });
    page.querySelectorAll('[data-sketch-view]').forEach(button=>button.addEventListener('click',()=>{
      const perspective=button.dataset.sketchView === 'perspective';
      summary.querySelector('.rb-plan').hidden=perspective;
      summary.querySelector('[data-perspective]').hidden=!perspective;
      page.querySelectorAll('[data-sketch-view]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
    }));
    page.querySelectorAll('[data-seats]').forEach(button=>button.addEventListener('click',()=>{
      const people=Number(button.dataset.seats);
      const size=round() ? {4:[110],6:[140],8:[170]}[people] : {4:[160,90],6:[200,95],8:[240,100]}[people];
      if(round()) form.elements['contact[diameter_cm]'].value=size[0];
      else {form.elements['contact[længde_cm]'].value=size[0];form.elements['contact[bredde_cm]'].value=size[1];}
      page.querySelector('[data-seat-note]').textContent='Vejledende udgangspunkt til '+people+' personer: '+(round()?'Ø '+size[0]:size.join(' × '))+' cm. Tilpas frit — den endelige plads afhænger af stole og understel.';
      sync();
    }));
    function drawPerspective() {
      const svg=summary.querySelector('[data-perspective] svg');
      const ns='http://www.w3.org/2000/svg'; svg.replaceChildren();
      const wood=value('træsort') === 'Massiv valnød' ? '#86644e' : value('træsort') === 'Massiv eg' ? '#c3a57a' : '#c5bcac';
      const edge=value('træsort') === 'Massiv valnød' ? '#654a39' : '#9b805d';
      const length=Number(value(round()?'diameter_cm':'længde_cm')) || (round()?140:220);
      const width=round()?length:Number(value('bredde_cm'))||95;
      const scale=Math.min(1.02,240/length,108/width);
      const l=length*scale, w=width*scale, height=75*scale;
      const project=(x,z,y=0)=>[200+x+z*.45,120+z*.38-x*.14+y];
      const points=ps=>ps.map(p=>p.map(n=>n.toFixed(2)).join(',')).join(' ');
      function polygon(ps,fill,stroke=edge){const el=document.createElementNS(ns,'polygon');el.setAttribute('points',points(ps));el.setAttribute('fill',fill);el.setAttribute('stroke',stroke);el.setAttribute('stroke-width','.7');svg.append(el);}
      function line(a,b,color,thickness=4){const el=document.createElementNS(ns,'line');el.setAttribute('x1',a[0]);el.setAttribute('y1',a[1]);el.setAttribute('x2',b[0]);el.setAttribute('y2',b[1]);el.setAttribute('stroke',color);el.setAttribute('stroke-width',thickness);el.setAttribute('stroke-linecap','round');svg.append(el);}
      const shadow=document.createElementNS(ns,'ellipse');shadow.setAttribute('cx','200');shadow.setAttribute('cy',String(125+height));shadow.setAttribute('rx',String(l*.55));shadow.setAttribute('ry',String(w*.22));shadow.setAttribute('fill','#000');shadow.setAttribute('opacity','.045');svg.append(shadow);
      const legs=value('ben');
      if(legs==='Pladeben i træ') {
        [-1,1].forEach(side=>{const x=side*l*.32;polygon([project(x,-w*.35,5),project(x,w*.35,5),project(x,w*.35,height),project(x,-w*.35,height)],wood);line(project(x,0,5),project(x,0,height),edge,1);});
      } else if(legs && legs !== 'Anden type ben') {
        const metal='#4b4a44';
        if(legs==='Stjernestel i stål') {[-1,1].forEach(a=>[-1,1].forEach(b=>line(project(0,0,8),project(a*l*.33,b*w*.38,height),metal,5)));}
        else [-1,1].forEach(side=>{const x=side*l*.32;
          if(legs==='X-ben i stål'){line(project(x,-w*.32,5),project(x,w*.36,height),metal,5);line(project(x,w*.32,5),project(x,-w*.36,height),metal,5);}
          else {const top=legs==='A-stel i stål'?.13:.27;line(project(x,-w*top,5),project(x,-w*.38,height),metal,5);line(project(x,w*top,5),project(x,w*.38,height),metal,5);line(project(x,-w*.27,height*.58),project(x,w*.27,height*.58),metal,4);}
        });
      }
      let top;
      if(round()) top=Array.from({length:64},(_,i)=>project(Math.cos(i*Math.PI/32)*l/2,Math.sin(i*Math.PI/32)*w/2));
      else top=[project(-l/2,-w/2),project(l/2,-w/2),project(l/2,w/2),project(-l/2,w/2)];
      polygon(top.map(([x,y])=>[x,y+5]),edge);polygon(top,wood);
      if(!round()) line(project(-l/2,0),project(l/2,0),edge,.8);
      // Frame the actual geometry without making small round tables disappear.
      const pad=24, minX=Math.min(...top.map(p=>p[0]))-pad, maxX=Math.max(...top.map(p=>p[0]))+pad;
      const minY=Math.min(...top.map(p=>p[1]))-pad, maxY=125+height+w*.22+pad;
      svg.setAttribute('viewBox',[minX,minY,maxX-minX,maxY-minY].join(' '));
      const label=page.querySelector('[data-perspective-note]');
      if(label) label.textContent=legs ? (legs==='Anden type ben'?'Dit ønskede understel afklares sammen.':legs+' · skematisk vist') : 'Vælg et understel i trin 3 for at se princippet.';
    }
    function sync() {
      toggle('[data-rect-dimensions]', !round());
      toggle('[data-round-dimensions]', round());
      toggle('[data-other-wood]', value('træsort') === 'Anden træsort');
      toggle('[data-other-legs]', value('ben') === 'Anden type ben');
      page.querySelector('[data-rect-presets]').hidden = round();
      page.querySelector('[data-round-presets]').hidden = !round();
      const length = value('længde_cm'), width = value('bredde_cm'), diameter = value('diameter_cm');
      const dimensions = round() ? (diameter ? 'Ø ' + diameter + ' cm' : 'Diameter afklares') : (length || width ? (length || '?') + ' × ' + (width || '?') + ' cm' : 'Afklares sammen');
      page.querySelector('[data-plan-size]').textContent = dimensions;
      page.querySelector('[data-preview-brief]').textContent = dimensions;
      drawPerspective();
      presets.querySelectorAll('[data-size]').forEach(button => {
        const match = round() ? button.dataset.size === diameter : button.dataset.size === length + ',' + width;
        button.setAttribute('aria-pressed', String(match));
      });
      const values = {
        form: round() ? 'Rundt' : 'Rektangulært', dimensions,
        træsort: value('træsort') === 'Anden træsort' && value('ønsket_anden_træsort') ? value('ønsket_anden_træsort') : value('træsort') || 'Afklares sammen',
        udtryk: value('udtryk') || 'Afklares sammen',
        ben: value('ben') === 'Anden type ben' && value('ønsket_anden_type_ben') ? value('ønsket_anden_type_ben') : value('ben') || 'Afklares sammen',
        tillægsplader: value('tillægsplader') || 'Afklares sammen'
      };
      Object.entries(values).forEach(([key, text]) => { summary.querySelector('[data-summary-key="' + key + '"]').textContent = text; });
      const labels = {form:'Form',dimensions:'Mål',træsort:'Træsort',udtryk:'Udtryk',ben:'Ben',tillægsplader:'Udtræk'};
      const summaryText = (origin ? 'Udgangspunkt: ' + origin + ' · ' : '') + Object.entries(values).map(([key,text])=>labels[key]+': '+text).join(' · ');
      detailReset.hidden = !stages[1].querySelector('input[type="radio"]:checked');
      form.querySelector('[data-design-summary-field]').value = summaryText;
      const finalSummary = form.querySelector('[data-final-summary]');
      finalSummary.replaceChildren();
      const title = document.createElement('h4'); title.textContent = 'Din bordidé'; finalSummary.append(title);
      const list = document.createElement('dl');
      const review = {...(origin ? {udgangspunkt: origin} : {}), ...values, ...(value('body').trim() ? {ønsker:value('body').trim()} : {})};
      Object.entries(review).forEach(([key, text]) => {
        const row=document.createElement('div'), term=document.createElement('dt'), definition=document.createElement('dd');
        term.textContent=labels[key] || (key === 'udgangspunkt' ? 'Udgangspunkt' : 'Dine ønsker'); definition.textContent=text;
        row.append(term,definition); list.append(row);
      }); finalSummary.append(list);
      const rect = summary.querySelector('[data-plan-rect]'), circle = summary.querySelector('[data-plan-round]'), seam = summary.querySelector('[data-plan-seam]');
      rect.toggleAttribute('hidden', round()); seam.toggleAttribute('hidden', round()); circle.toggleAttribute('hidden', !round());
      const ratio = Math.min(5, Math.max(.45, (Number(length) || 240) / (Number(width) || 100)));
      const w = Math.min(260, 160 * ratio), h = w / ratio;
      rect.setAttribute('x', (320-w)/2); rect.setAttribute('y', (220-h)/2); rect.setAttribute('width', w); rect.setAttribute('height', h);
      seam.setAttribute('d', 'M' + ((320-w)/2) + ' 110H' + ((320+w)/2));
      const reference = page.querySelector('[data-material-reference]');
      reference.hidden = !['Massiv eg','Massiv valnød'].includes(value('træsort'));
      reference.querySelector('[data-reference-oak]').hidden = value('træsort') !== 'Massiv eg';
      reference.querySelector('[data-reference-walnut]').hidden = value('træsort') !== 'Massiv valnød';
      const color = value('træsort') === 'Massiv valnød' ? '#79604b' : value('træsort') === 'Anden træsort' ? '#c8bfb0' : '#b2936b';
      rect.setAttribute('fill',color); circle.setAttribute('fill',color);
    }
    function validCurrentStage() {
      return [...stages[stage].querySelectorAll('input,textarea,select')].every(field => field.disabled || field.reportValidity());
    }
    function showStage(index, focus = true) {
      stage = index;
      stepStatus.textContent = 'Trin ' + (stage + 1) + ' af 4 · ' + ['Form & mål','Træ & udtryk','Understel & udtræk','Din forespørgsel'][stage];
      stages.forEach((node, i) => { node.hidden = i !== stage; });
      navButtons.forEach((button, i) => { if (i === stage) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
      back.disabled = stage === 0;
      next.hidden = stage === stages.length - 1;
      next.textContent = ['Vælg materiale →','Vælg understel →','Se min bordidé →'][stage] || 'Videre →';
      submitArea.hidden = stage !== stages.length - 1;
      if (focus) stages[stage].querySelector('h3').focus();
    }
    navButtons.forEach(button => button.addEventListener('click', () => {
      const target = Number(button.dataset.goStage);
      if (target < stage || validCurrentStage()) showStage(target);
    }));
    back.addEventListener('click', () => showStage(Math.max(0, stage-1)));
    next.addEventListener('click', () => { if (validCurrentStage()) showStage(Math.min(stages.length-1, stage+1)); });
    detailReset.addEventListener('click',()=>{
      stages[1].querySelectorAll('input[type="radio"]').forEach(field=>{field.checked=false;});
      sync();stages[1].querySelector('h3').focus();
    });
    page.querySelectorAll('[data-bord-inspiration]').forEach(link => link.addEventListener('click', () => {
      origin = link.dataset.bordInspiration || '';
      originField.value = origin;
      originLabel.textContent = 'Dit udgangspunkt: ' + origin + '. Du kan tilpasse ønskerne nedenfor.';
      originLabel.hidden = false;
      [['form', link.dataset.bordShape], ['træsort', link.dataset.bordWood]].forEach(([key, choice]) => {
        [...form.querySelectorAll('input[type="radio"]')].filter(input => input.name === 'contact[' + key + ']').forEach(input => { input.checked = input.value === choice; });
      });
      sync();
      showStage(0);
    }));
    presets.querySelectorAll('[data-size]').forEach(button => button.addEventListener('click', () => {
      const numbers=button.dataset.size.split(',');
      if(round()) form.elements['contact[diameter_cm]'].value=numbers[0];
      else {form.elements['contact[længde_cm]'].value=numbers[0];form.elements['contact[bredde_cm]'].value=numbers[1];}
      sync();
    }));
    editChoices.addEventListener('click', () => showStage(0));
    form.addEventListener('input', sync);
    form.addEventListener('change', sync);
    form.addEventListener('invalid', event => {
      const targetStage = event.target.closest('[data-stage]');
      if (targetStage && Number(targetStage.dataset.stage) !== stage) showStage(Number(targetStage.dataset.stage), false);
    }, true);
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('input') && stage < stages.length-1) {
        event.preventDefault();
        if (validCurrentStage()) showStage(stage+1);
      }
    });
    form.addEventListener('submit', sync);
    form.dataset.enhanced = 'true';
    saveTools.hidden = false;
    stepStatus.hidden = false; presets.hidden = false; editChoices.hidden = false;
    nav.hidden = false; controls.hidden = false; summary.hidden = false;
    sync();
    const success = form.querySelector('.rj-table-design__success');
    if (success) {
      [...stages, nav, controls, summary, submitArea, stepStatus, saveTools].forEach(node => { node.hidden = true; });
      success.focus();
      return;
    }
    const hasFeedback = form.querySelector('.errors');
    showStage(hasFeedback ? stages.length-1 : 0, false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
